import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=57828c80"
import script from "./Today.vue?vue&type=script&lang=js"
export * from "./Today.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports